import Vue from "vue";
import Vuesax from "vuesax";
import Vuex from "vuex";
import { ApiConfigs, authKioskHeader } from "./_helpers";
import App from "./App.vue";

import Bugsnag from "@bugsnag/js";
import BugsnagPluginVue from "@bugsnag/plugin-vue";
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";
Sentry.init({
  Vue,
  dsn: "https://24dd660f743f4979a511a94db2876333@o1315906.ingest.sentry.io/6568024",
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ["localhost", "display.liberrex.com", /^\//],
    }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});
/* Bugsnag.start({
    apiKey: '70ea3c7963d1fcd956e455613d5be2ea',
    plugins: [new BugsnagPluginVue()]
}) */
import "vuesax/dist/vuesax.css"; //Vuesax styles
import "material-icons/iconfont/material-icons.css";
// Vuex Store
import { store } from "./_store";
// Theme Configurations
import "../themeConfig.js";
// Perfectscrollbar
// import PerfectScrollbar from "vue2-perfect-scrollbar";
// import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";
// Vue.use(PerfectScrollbar);
import Vuebar from "vuebar";

//import promise
import "es6-promise/auto";

import CountryFlag from "vue-country-flag";
Vue.component("country-flag", CountryFlag);

Vue.use(Vuebar);
Vue.use(Vuex);

// Theme Configurations
import "prismjs";
import "prismjs/themes/prism.css";
import VsPrism from "./components/prism/VsPrism.vue";
Vue.component(VsPrism.name, VsPrism);
import VsSidebarGroup from "./components/vs-sidebar-group/Sidebar-Group.vue";
Vue.component(VsSidebarGroup.name, VsSidebarGroup);
// i18n
import i18n from "./i18n/i18n.js";
if (!localStorage.getItem("Language")) {
  localStorage.setItem("Language", "en");
}
// Vue Router
import { router } from "./_helpers";
Vue.config.productionTip = false;

Vue.use(Vuesax);

// check display version
if (!localStorage.getItem("version")) {
  localStorage.setItem("version", "V1");
} else if (localStorage.getItem("version") == 'V2') {
  location.href = 'https://display-v2.liberrex.com';
}

const VueInputMask = require("vue-inputmask").default;
Vue.use(VueInputMask);

new Vue({
  store,
  router,
  i18n,
  render: (h) => h(App),
}).$mount("#app");

import '@/assets/scss/style.scss'
if(i18n.locale == "ar"){
  import('@/assets/scss/ar.scss').then(() => {
    console.log("Arabic display");
  })
}
//LoadScript
import LoadScript from "vue-plugin-load-script";
Vue.use(LoadScript);

// Moment
import moment from "moment";
moment.locale(i18n.locale);
Vue.prototype.$moment = moment;

localStorage.setItem("originalHost", process.env.VUE_APP_API_URL_TN);
localStorage.setItem("originalWs", process.env.VUE_APP_WSS_URL);

// import Pusher from 'pusher-js' // import Pusher
// Vue.prototype.$pusher = new Pusher(process.env.VUE_APP_PUSHER_ID, {
//     cluster: 'eu',
//     encrypted: true,
//     authEndpoint: ApiConfigs.broadcast_url+ApiConfigs.pusher.auth,
//     auth: {
//         headers: { ...authKioskHeader() }
//     }
// });

import Echo from "laravel-echo";

window.Pusher = require("pusher-js");

Vue.prototype.$pusher = new Echo({
  broadcaster: "pusher",
  key: process.env.VUE_APP_PUSHER_KEY,
  forceTLS: false,
  wsHost: (process.env.VUE_APP_EDIT_HOST === "true" && localStorage.getItem('host') != null) ? localStorage.getItem('ws') : process.env.VUE_APP_WSS_URL,
  wsPort: 6001,
  disableStats: false,
  authEndpoint: ApiConfigs.broadcast_url + ApiConfigs.pusher.auth,
  enabledTransports: ["ws", "wss"],
  auth: {
    headers: { ...authKioskHeader() },
  },
});

//Bugsnag.getPlugin('vue').installVueErrorHandler(Vue);

// declare duration between each ping
Vue.prototype.$pingInterval = process.env.VUE_APP_PING_INT
